import React from "react";
import {Typography} from "@material-ui/core";
const StepTitle = ({title}: { title: String }) => {
    return <Typography variant='caption'>{title}</Typography>;
}

export default StepTitle;